import React from "react"
import { DioboxEvent } from "sharedTypes"
import { Box, Heading, Text } from "@chakra-ui/react"
import { Control, FieldValues } from "react-hook-form"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { useCurrentEvent } from "queries/events"
import AutoSubmitForm from "components/ReactHookForm/AutoSubmitForm"
import { Boolean } from "utilities/enums"
import BuilderLayout from "components/Builder/BuilderLayout"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import { CCEmailsFormFields, CC_EMAILS_INTRO, CC_EMAILS_TITLE } from "pages/EventShow/Settings/EmailNotifications"
import RecipientCheckboxes from "components/RecipientCheckboxes"
import useCurrentPlanType from "utilities/useCurrentPlanType"

type Props<T extends FieldValues> = {
  event: DioboxEvent
  control: Control<T, object>
  updateEvent: (params: {}) => Promise<void>
}

const Recipients = <T extends FieldValues, >({
  event, control, updateEvent,
}: Props<T>) => (
  <BuilderLayout sidePanel={<SidePanel updateEvent={updateEvent} />}>
    <Box w={550} m="auto" p={8}>
      <Text fontSize="lg" fontWeight="bold" mb={8}>Lists</Text>
      <RecipientCheckboxes
        event={event}
        control={control}
      />
    </Box>
  </BuilderLayout>
  )

type SidePanelProps = {
  updateEvent: (params: {}) => Promise<void>;
}

const SidePanel = ({ updateEvent }: SidePanelProps) => {
  const { corporateFeaturesEnabled } = useCurrentPlanType()

  const { data: { ccEmailsEnabled } } = useCurrentEvent()

  return (
    <>
      <SidePanelHeader>Sending Options</SidePanelHeader>
      <Box py={10} px={6}>
        <Heading fontSize="lg" fontWeight="normal" mb={3}>{CC_EMAILS_TITLE}</Heading>
        <Text mb={4}>{CC_EMAILS_INTRO}</Text>
        <AutoSubmitForm
          defaultValues={{ ccEmailsEnabled: ccEmailsEnabled ? Boolean.True : Boolean.False }}
          onSubmit={
            ({
              ccEmailsEnabled: enabled,
            }) => updateEvent({ ccEmailsEnabled: enabled === Boolean.True })
          }
        >
          {({ control }) => (
            <>
              <CCEmailsFormFields control={control} isCorporate={corporateFeaturesEnabled} />
              {!corporateFeaturesEnabled && <UpgradeAlert text="This Feature requires a Corporate Subscription." />}
            </>
          )}
        </AutoSubmitForm>
      </Box>
    </>
  )
}

export default Recipients
